<mat-progress-bar
  class="example-margin"
  color="primary"
  mode="query"
  value="50"
  bufferValue="75"
>
</mat-progress-bar>
